


















import { Component, Vue } from 'vue-property-decorator';
import {Actions, Mutations} from '@/ts/store/Constants';
import TenantNotificationItem from '@/components/Globals/Overlay/Components/Items/TenantNotificationItem.vue';
import LogNotification from '@/ts/instances/notifications/LogNotification';

@Component({
    name: 'TenantNotifications',
    components: {
        TenantNotificationItem,
    },
})
export default class TenantNotifications extends Vue {
    constructor() {
        super();
    }

    get logs(): LogNotification[] {
        return this.$store.getters['TenantNotifications/getTenantNotificationLogs'];
    }

    get page(): number {
        return this.$store.getters['TenantNotifications/getTenantLogsPage'];
    }

    get lastPage(): number {
        return this.$store.getters['TenantNotifications/getTenantLogsLastPage'];
    }

    get unreadNotificationCount(): string | number {
        return this.$store.getters['TenantNotifications/getTenantUnreadNotificationsCount'];
    }

    public markAsRead() {
        this.$store.dispatch(Actions.MARK_TENANT_ALL_NOTIFICATION_AS_SEEN);
    }

    public refresh(done: any) {
        this.$store.commit(Mutations.SET_TENANT_LOGS_PAGE, 1);

        this.$store.dispatch(Actions.FETCH_TENANT_LOGS_NOTIFICATIONS, {
            page: 1,
            hardReload: true,
        }).then(() => {
            done();
        });
    }

    public load() {
        if (this.lastPage === this.page) {
            return;
        }

        this.$store.dispatch(Actions.FETCH_TENANT_LOGS_NOTIFICATIONS, {
            page: this.page,
        });
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_TENANT_LOGS_NOTIFICATIONS, {
            page: 1,
            hardReload: true,
        });
    }
}
